var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBarChart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512,480v32H0V0h32v480H512z M228.906,177.719l130.719,32.656L404.875,135l41,24.625L448,32L336.406,93.938l41,24.625 l-33.031,55.063l-125.281-31.344L84.688,276.688l22.625,22.625L228.906,177.719z M192,448h64V217.469l-17.281-4.313L192,259.875V448 z M96,333.25V448h64V291.875l-52.688,52.688L96,333.25z M384,232v216h64V198.219l-32.156-19.281L384,232z M352,448V241.469l-64-16 V448H352z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBarChart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bar-chart.b8eb96cd.svg";
export { ForwardRef as ReactComponent };